// Copyright (c) 2016 Deere & Company

import { buildDealerString } from '../components/build-dealer-string';

export const buildDealer = (dealer, displayFormatKey) => {

    if (dealer.account === '') {

        return '---';

    }

    const dealerFormat = displayFormatKey;

    return buildDealerString(dealerFormat, dealer);

};
